import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const CategoriesDetails = lazy(() => import('@/containers/Views/Categories/CategoriesPage'));
const CategoryProductManager = lazy(
  () => import('@/containers/Views/Categories/CategoryProductManager'),
);
const CategoryMixManager = lazy(
  () => import('@/containers/Views/Categories/CategoryMixManager'),
);

const CategoriesRouter = (
  <Route path="categories">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.Categories} 
          permissions={EBasicActions.Find}
        >
          <CategoriesDetails />
        </PrivateRoute>
      )} 
    />
    <Route 
      path=":id/product_manager"
      element={(
        <PrivateRoute 
          pageName={EPage.Categories} 
          permissions={[
            EBasicActions.Create,
            EBasicActions.Get,
            EBasicActions.Delete,
          ]}
        >
          <CategoryProductManager />
        </PrivateRoute>
      )}
    />
    <Route 
      path=":id/mix_manager"
      element={(
        <PrivateRoute 
          pageName={EPage.Categories} 
          permissions={[
            EBasicActions.Create,
            EBasicActions.Get,
            EBasicActions.Delete,
          ]}
        >
          <CategoryMixManager />
        </PrivateRoute>
      )}
    />
  </Route>
);


export default CategoriesRouter;
